import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import API from '../../../Utils/api';
import { useUser } from '../../../Context/useUser';
import { Button, Field } from '../../../Components/AdminSurface';

const MIN_LENGTH = 6;

// Same contract as before the move: re-verifies the current password server-side.
export default function ChangePasswordForm() {
    const { user } = useUser();
    const {
        register,
        handleSubmit,
        reset,
        setError,
        formState: { errors, isSubmitting }
    } = useForm();

    const onSubmit = async ({ currentPassword, newPassword, confirmPassword }) => {
        if (newPassword !== confirmPassword) {
            setError('confirmPassword', { type: 'mismatch', message: 'New passwords do not match.' });
            toast.error('New passwords do not match.');
            return;
        }
        try {
            await API.updatePassword({ userId: user._id, oldPassword: currentPassword, newPassword });
            toast.success('Password updated successfully.');
            reset();
        } catch (e) {
            toast.error(e?.response?.data?.error || 'Failed to update password.');
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} noValidate style={{ display: 'grid', gap: 12, maxWidth: 360 }}>
            <Field
                label="Current Password"
                type="password"
                autoComplete="current-password"
                error={errors.currentPassword && 'Current password is required'}
                {...register('currentPassword', { required: true })}
            />
            <Field
                label="New Password"
                type="password"
                autoComplete="new-password"
                hint={`At least ${MIN_LENGTH} characters.`}
                error={errors.newPassword && `New password is required (min ${MIN_LENGTH} chars)`}
                {...register('newPassword', { required: true, minLength: MIN_LENGTH })}
            />
            <Field
                label="Confirm New Password"
                type="password"
                autoComplete="new-password"
                error={
                    errors.confirmPassword &&
                    (errors.confirmPassword.type === 'mismatch' ? errors.confirmPassword.message : 'Please confirm your new password')
                }
                {...register('confirmPassword', { required: true })}
            />
            <div>
                <Button type="submit" variant="primary" busy={isSubmitting}>
                    {isSubmitting ? 'Updating...' : 'Update Password'}
                </Button>
            </div>
        </form>
    );
}
